function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.905 43.08a5.88 5.88 0 11-11.76 0 5.88 5.88 0 0111.76 0z",
  fill: "#FFCE32"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.48 71.862h15.475V49.58L35.05 42.77l16.713 6.19v22.746h76.135v20.583H3.481V71.862z",
  fill: "#F8FBCF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.5 99.098h129.254V.862H.5v98.236z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#delivery-van_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.288 59.483h6.19v-6.19h-6.19v6.19zM23.288 70.625h6.19v-6.19h-6.19v6.19z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.48 99.097h125.036V85.48H3.48v13.617z",
  fill: "#F2F4F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.19 81.793h52.082v-53.88H76.189v53.88z",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.19 82.492V39.94H57.687l-8.787 17.113-14.547 6.945v18.494h41.835z",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.882 82.782h97.872v-7.909H31.882v7.909z",
  fill: "#406367"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.988 57.053H72.49V42.715H60.926l-6.938 14.338z",
  fill: "#D2B982"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.014 63.991h6.938v-2.775h-6.938v2.775zM68.413 42.715L63.24 57.053h-9.713l6.938-14.338h7.95z",
  fill: "#F8FBCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.713 61.916l-4.36 8.014v-5.932l4.36-2.082z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.875 27.914l52.117 46.958H75.875V27.914z",
  fill: "#F8FBCF"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.942 71.706h20.01v20.01h-20.01v-20.01z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#delivery-van_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.75 72.631c-5.016 2.319-7.2 8.263-4.882 13.277 2.319 5.015 8.264 7.2 13.277 4.881 5.015-2.318 7.2-8.263 4.882-13.276-2.319-5.015-8.263-7.2-13.278-4.882z",
  fill: "#002F34"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.34 78.238a3.827 3.827 0 11-1.867 5.08 3.832 3.832 0 011.868-5.08z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M99.73 71.706h20.01v20.01H99.73v-20.01z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#delivery-van_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.537 72.631c-5.014 2.319-7.2 8.263-4.881 13.277 2.318 5.015 8.263 7.2 13.277 4.881 5.014-2.318 7.199-8.263 4.881-13.276-2.318-5.015-8.262-7.2-13.276-4.882h-.001z",
  fill: "#002F34"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.128 78.238a3.828 3.828 0 113.214 6.948 3.828 3.828 0 01-3.214-6.948z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.143 26.057a4.642 4.642 0 00-4.55-5.57c-.734-.001-1.427.175-2.045.479a8.347 8.347 0 00-15.462 2.718 3.069 3.069 0 00-.752-.103 3.096 3.096 0 00-3.033 2.476h25.842z",
  fill: "#CEDDFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.65 11.82c.07-.343.107-1.042.107-1.405a5.307 5.307 0 00-5.307-5.308c-.841 0-1.633.201-2.34.55C94.46 2.794 91.377.862 87.835.862c-4.711 0-8.617 3.414-9.4 7.901a3.527 3.527 0 00-.86-.117c-1.712 0-3.139 1.56-3.468 3.174h29.543z",
  fill: "#3A77FF"
}));

const SvgDeliveryVan = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 130,
  height: 100,
  fill: "none"
}, props), _ref, _ref2, /*#__PURE__*/React.createElement("mask", {
  id: "delivery-van_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 130,
  height: 100
}, _ref3), _ref4, /*#__PURE__*/React.createElement("mask", {
  id: "delivery-van_svg__b",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 37,
  y: 71,
  width: 21,
  height: 21
}, _ref5), _ref6, _ref7, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "delivery-van_svg__c",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 99,
  y: 71,
  width: 21,
  height: 21
}, _ref8), _ref9), _ref10);

export default SvgDeliveryVan;